/* acaciasupplies — fit-tool.js
   El filtro de medidas de la home (`snippets/fit-tool.liquid`, contexto
   home). Filtra en cliente las tarjetas `object-teaser` de la página, sin
   recarga. En el Índice no hace nada: allí el motor es `assets/index.js`.

   Contrato de datos, en cada tarjeta `[data-teaser]`:
     data-teaser-handle   el handle (el recuento cuenta handles distintos)
     data-fit-laptop      13 | 14 | 16 | 0 (0 = sin dato: no cabe nada)
     data-fit-extras      a4 bottle_500 umbrella, separados por espacio
   Se esconde el `[data-teaser-slot]` más cercano (el <li> de la retícula)
   o, si no hay, la tarjeta. Un objeto sin dato no cumple ninguna selección:
   sin dato no hay un «sí». */
(function () {
  'use strict';

  var ALLOWED = ['a4', 'bottle_500', 'umbrella'];

  function words(value) {
    return String(value || '').split(/\s+/).filter(Boolean);
  }

  function init(form) {
    var scope = form.getAttribute('data-fit-scope');
    var root = scope ? document.querySelector(scope) : document;
    if (!root) return;

    var select = form.querySelector('select[name="laptop"]');
    var boxes = Array.prototype.slice.call(form.querySelectorAll('input[name="fits"]'));
    var result = form.querySelector('[data-fit-result]');
    var none = form.querySelector('[data-fit-none]');
    var link = form.querySelector('[data-fit-index]');
    var base = form.getAttribute('action') || '/collections/index';

    function apply() {
      var laptop = select ? parseInt(select.value, 10) || 0 : 0;
      var extras = boxes.filter(function (box) {
        return box.checked && ALLOWED.indexOf(box.value) !== -1;
      }).map(function (box) {
        return box.value;
      });
      var active = laptop > 0 || extras.length > 0;
      var seen = {};
      var fit = {};
      var m = 0;
      var n = 0;

      Array.prototype.forEach.call(root.querySelectorAll('[data-teaser]'), function (card) {
        var handle = card.getAttribute('data-teaser-handle') || '';
        var has = words(card.getAttribute('data-fit-extras'));
        var ok = (parseInt(card.getAttribute('data-fit-laptop'), 10) || 0) >= laptop;
        for (var i = 0; ok && i < extras.length; i++) {
          if (has.indexOf(extras[i]) === -1) ok = false;
        }
        var slot = card.closest('[data-teaser-slot]') || card;
        slot.hidden = !ok;
        if (!seen[handle]) {
          seen[handle] = 1;
          m++;
        }
        if (ok && !fit[handle]) {
          fit[handle] = 1;
          n++;
        }
      });

      if (result) result.textContent = active ? n + ' of ' + m + ' fit' : '';
      if (none) none.hidden = !(active && n === 0);
      if (link) {
        var q = [];
        if (laptop) q.push('laptop=' + laptop);
        extras.forEach(function (value) {
          q.push('fits=' + value);
        });
        link.setAttribute('href', base + (q.length ? '?' + q.join('&') : ''));
      }
    }

    form.addEventListener('change', apply);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      apply();
    });
    apply();
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-fit-tool="home"]'), init);
})();
